/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Pit2_DInputs */

const en_sorter_pit2_d = /** @type {(inputs: Sorter_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because collation is locale dependent and numeric keys are repositioned, two environments can produce different byte sequences from the same input. Do not hash sorted output and compare it against a hash computed by another implementation. Use a specified canonicalization scheme such as JCS, which mandates code point ordering, if you need that guarantee.`)
};

const ko_sorter_pit2_d = /** @type {(inputs: Sorter_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬 규칙이 로케일에 의존하고 숫자 키의 위치가 바뀌므로, 같은 입력에서 두 환경이 다른 바이트 열을 만들 수 있습니다. 정렬 출력을 해시해서 다른 구현이 계산한 해시와 비교하지 마세요. 그런 보장이 필요하면 코드 포인트 순서를 규정하는 JCS 같은 정규화 규격을 쓰세요.`)
};

const ja_sorter_pit2_d = /** @type {(inputs: Sorter_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`照合順序がロケールに依存し数値キーの位置が変わるため、同じ入力から 2 つの環境が異なるバイト列を作ることがあります。並べ替えた出力をハッシュして、別の実装が計算したハッシュと比べないでください。その保証が必要なら、コードポイント順を規定する JCS のような正規化仕様を使ってください。`)
};

/**
* | output |
* | --- |
* | "Because collation is locale dependent and numeric keys are repositioned, two environments can produce different byte sequences from the same input. Do not ha..." |
*
* @param {Sorter_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_pit2_d = /** @type {((inputs?: Sorter_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_pit2_d(inputs)
	if (locale === "ko") return ko_sorter_pit2_d(inputs)
	return ja_sorter_pit2_d(inputs)
});